import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '@showbie-socrative/socrative-utils/lib/translator/client';

import {
  IncludeCorrectAnswers,
  IncludeExplanations,
  ReportOptionType,
} from '../ReportOption';
import {
  AssessmentsCommonProps,
  AssessmentsExportReportsPanel,
} from './AssessmentsExportReportsPanel';

const AssessmentsExportReportsIndividual = (props: AssessmentsCommonProps) => {
  const reportOptions: ReportOptionType[] = [
      IncludeExplanations,
      IncludeCorrectAnswers,
    ];

  return (
    <AssessmentsExportReportsPanel
      {...props}
      description={translate(
        'Export a personalized results PDF for each student who took part in the activity.'
      )}
      title={translate('Individual Student PDFs')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.IndividualStudentPDF}
    />
  );
};

export { AssessmentsExportReportsIndividual };
export default AssessmentsExportReportsIndividual;

  